export interface ClosedSearchParams {
    aircraftRegistration: string;
    problemText: string;
    station: string;
    outOfServiceTimeStart: string;
    outOfServiceTimeEnd: string;
    ataCode: string;
    eventType: string[];
    fleetType: string;
  }

  export interface ClosedParamsErrorState {
    isErrorTail: boolean;
    isErrorStation: boolean;
    isOTSStartDateError: boolean;
    isATAError: boolean;
    isFleetTypeError: boolean;
  }

  export enum SortField {
    AircraftRegistration = "AIRCRAFTREGISTRATION",
    Station = "STATION",
    OTSStartTime = "OTSSTARTTIME",
  }
  
  export enum SortOrder {
    Asc = "ASC",
    Desc = "DESC",
  }
  
  export interface ClosedSortingParams {
    sortBy: SortField;
    sortOrder: SortOrder;
  }
  